import React, { useState, useEffect, useCallback } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import SSPCommonModal from '../../CommonComponents/SSPCommonModal/SSPCommonModal';
import { PageBar, SSPCommonButton, SSPCommonVideo } from '../../CommonComponents';
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Close } from "@mui/icons-material";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    IconButton,
    CircularProgress,
} from "@mui/material";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import styled from 'styled-components';
import { post } from "../../services";
import Cookies from "js-cookie";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import styles, { columns } from './Styles';
const base = "https://";

const StyledDatePicker = styled(DatePicker)`
width: 240px;
height: 40px;
border: 1px solid #ccc;
border-radius: 4px;
padding: 8px;
font-size: 14px;
color: #333;
background-color: #fff;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
box-sizing: border-box;
`;

const View_Transfer = ({ }) => {
    const id = Cookies.get("ssp_id");
    const getCurrentDate = () => {
        return new Date();
    };
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const currentDate = getCurrentDate();
    const [loading, setLoading] = useState(false);
    // const [selectedOption, setSelectedOption] = useState("Last 7 days");
    const [selectedOption, setSelectedOption] = useState("Select Creation Date");

    const [storesData, setStoresData] = useState([]);
    const [storesModalOpen, setStoresModalOpen] = useState(false);
    const [fromlocation, setFromLocation] = useState("");
    const [tolocation, setToLocation] = useState("");
    const [fromlocationOptions, setFromLocationOptions] = useState([]);
    const [tolocationOptions, setToLocationOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [rows, setRows] = useState([]);
    const [originalRowsData, setOriginalRowsData] = useState([]);
    const [uploadername, setUploadername] = useState("");
    const [uploaderOptions, setUploaderOptions] = useState([]);

    const handleChangeUploadername = (event) => {
        setUploadername(event.target.value);
    };

    const handleImage = async (rowData) => {
        setLoading(true)
        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/generate_images_url",
            {
                "order_no": Number(rowData?.order_no)
            },
            true,
            false
        );
        if (response?.status === "success") {
            setLoading(false)
            setImages(response?.presigned_img_urls);
            if (response?.presigned_img_urls?.length > 0) {
                handleViewImages(response?.presigned_img_urls)

            } else {
                setLoading(false)
                setmessage("No Image Available");
                setmodalOpener(true);
            }

        } else {
            setLoading(false)
            setmessage(response?.message);
            setmodalOpener(true);
        }

    }
    const handleViewImages = useCallback((imageUrls) => {
        setImages(imageUrls);
        setCurrentImageIndex(0);
        setOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const handleNext = useCallback(() => {
        if (currentImageIndex < images?.length - 1) {
            setCurrentImageIndex((prevIndex) => prevIndex + 1);
        }
    }, [currentImageIndex, images?.length]);

    const handlePrev = useCallback(() => {
        if (currentImageIndex > 0) {
            setCurrentImageIndex((prevIndex) => prevIndex - 1);
        }
    }, [currentImageIndex]);

    const handleChangeFromLocation = (event) => {
        setFromLocation(event.target.value);
    };

    const handleChangeToLocation = (event) => {
        setToLocation(event.target.value);
    };

    const today = currentDate;
    useEffect(() => {
        const currentDate = new Date();
        const lastWeekDate = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        setStartDate(lastWeekDate);
        setEndDate(currentDate);
    }, []);

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
        const currentDate = new Date();
        const yesterdayDate = new Date(currentDate.getTime() - 1 * 24 * 60 * 60 * 1000);

        if (event.target.value === "Today") {
            setStartDate(currentDate);
            setEndDate(currentDate);
        } else if (event.target.value === "Yesterday") {
            setStartDate(yesterdayDate);
            setEndDate(yesterdayDate);
        } else if (event.target.value === "This Month") {
            setStartDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
            setEndDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0));
        } else if (event.target.value === "Last Month") {
            const lastMonthStart = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
            const lastMonthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
            setStartDate(lastMonthStart);
            setEndDate(lastMonthEnd);
        } else if (event.target.value === "Last 7 days") {
            setStartDate(new Date(currentDate.getTime() - 6 * 24 * 60 * 60 * 1000));
            setEndDate(currentDate);
        } else if (event.target.value === "Last 30 days") {
            setStartDate(new Date(currentDate.getTime() - 29 * 24 * 60 * 60 * 1000));
            setEndDate(currentDate);
        } else if (event.target.value === "Custom") {
            setStartDate(null);
            setEndDate(null);
        }
    };

    const handleStartDateChange = (date) => {
        setStartDate(date ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : null);
    };
    const handleEndDateChange = (date) => {
        setEndDate(date ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59) : null);
    };

    const getMonthName = (date) => {
        const months = [
            "Jan",
            "Feb",
            "March",
            "April",
            "May",
            "June",
            "July",
            "Aug",
            "Sept",
            "Oct",
            "Nov",
            "Dec",
        ];
        return months[date.getMonth()];
    };
    const formatDate = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}/${month}/${year}`;
    };


    const rowFetch = async () => {
        setmessage("Fetching Data");
        setLoading(true);
        let response = await post(
            base +
            "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/view_to_requests",
            {},
            true,
            false
        );
        if (response.status === "success") {
            const rowsData = response.view_list.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setOriginalRowsData(rowsData);
            setRows(rowsData);
            const uniqueFromLocationOptions = Array.from(new Set(rowsData?.map((row) => row?.from_loc_name)));
            const uniqueToLocationOptions = Array.from(new Set(rowsData?.map((row) => row?.to_loc_name)));
            const uniqueUploaderNameOptions = Array.from(new Set(rowsData?.map((row) => row?.uploder_name)));

            setUploaderOptions(uniqueUploaderNameOptions);
            setFromLocationOptions(uniqueFromLocationOptions);
            setToLocationOptions(uniqueToLocationOptions);
            setLoading(false);

        }
        else {
            setLoading(false);
        }
    }
    useEffect(() => {
        rowFetch();
    }, []);

    const handleFilterData = () => {
        setLoading(true)
        const formattedStartDate = startDate ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()) : null;
        const formattedEndDate = endDate ? new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59) : null;
        const filteredData = originalRowsData.filter((row) => {
            const rowDateParts = row.create_date.split('-');
            const rowDate = new Date(
                parseInt(rowDateParts[2], 10),
                parseInt(rowDateParts[1], 10) - 1,
                parseInt(rowDateParts[0], 10)
            );
            const dateMatch = !startDate || (rowDate >= formattedStartDate && rowDate <= formattedEndDate);
            const fromlocationMatch = fromlocation === "" || row.from_loc_name === fromlocation;
            const tolocationMatch = tolocation === "" || row.to_loc_name === tolocation;
            const uploaderNameMatch = uploadername === "" ||
                (row.uploder_name && row.uploder_name?.toLowerCase() === uploadername?.toLowerCase());

            return dateMatch && fromlocationMatch && tolocationMatch && uploaderNameMatch;
        });

        setRows(filteredData);
        setLoading(false)
    };

    const handleDownloadInvoice = async (url) => {
        if (url) {
            let response = await post(
                base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/generate_presign_url",
                {
                    "file_location": url
                },
                true,
                false
            );
            if (response?.status === "success") {
                window.open(response?.presigned_url
                );

            } else {
                setmessage(response?.message);
                setmodalOpener(true);
            }

        } else {
            setmessage("No invoice available");
            setmodalOpener(true);
        }
    };
    const handleDownloadEwb = async (url) => {
        if (url) {
            let response = await post(
                base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/generate_presign_url",
                {
                    "file_location": url
                },
                true,
                false
            );
            if (response?.status === "success") {
                window.open(response?.presigned_url
                );

            } else {
                setmessage(response?.message);
                setmodalOpener(true);
            }

        } else {
            setmessage("No EWB available");
            setmodalOpener(true);
        }

    };

    const handleViewDataClick = (rowData) => {
        setStoresData(rowData.asset_details);
        setStoresModalOpen(true);
    };

    const clearFilter = () => {
        window.location.reload();
        setFromLocation("");
        setToLocation("");

        setUploaderOptions([]);
        setFromLocationOptions([]);
        setToLocationOptions([]);
    }




    const StoresDataTable = ({ data }) => (
        <>
            <IconButton
                onClick={() => setStoresModalOpen(false)}
                sx={styles.iconButton}
            >
                <Close fontSize="medium" />
            </IconButton>
            <Table>
                <TableHead>
                    <TableRow>
                        {["Asset ID", "Asset Description", "Value", "Current Assignee", "New Assignee",].map(
                            (header) => (
                                <TableCell key={header} style={styles.headerCell}>
                                    {header}
                                </TableCell>
                            )
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell style={styles.cell}>{item.asset_id}</TableCell>
                            <TableCell style={styles.cell}>
                                {item.asset_description}
                            </TableCell>
                            <TableCell style={styles.cell}>{item.asset_value}</TableCell>
                            <TableCell style={styles.cell}>
                                {item.current_assignee}
                            </TableCell>
                            <TableCell style={styles.cell}>{item.new_assignee}</TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );

    const renderImageSliderDialog = () => (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: styles.dialogPaper,
            }}
        >
            <IconButton onClick={handleClose} sx={styles.iconButton}>
                <Close fontSize="medium" />
            </IconButton>

            <DialogContent sx={styles.dialogContent}>
                {images?.length > 0 ? (
                    <>
                        <IconButton
                            onClick={handlePrev}
                            disabled={currentImageIndex === 0}
                            sx={styles.prevButton}
                        >
                            <ChevronLeft fontSize="large" />
                        </IconButton>
                        <img
                            src={images[currentImageIndex]}
                            alt={`Broken Image`}
                            style={styles.image}
                        />
                        <IconButton
                            onClick={handleNext}
                            disabled={currentImageIndex === images?.length - 1}
                            sx={styles.nextButton}
                        >
                            <ChevronRight fontSize="large" />
                        </IconButton>
                    </>
                ) : (
                    <Typography variant="body1" color="textSecondary" sx={styles.noImage}>
                        No Image Available
                    </Typography>
                )}
            </DialogContent>
        </Dialog>
    );

    return (
        <>
            <Box sx={styles.parentBox}>
                <PageBar text="Asset Management: View Transfer Requests" />
                <Card sx={styles.filterCard} >
                    {/* <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={" Filters"}
                        titleTypographyProps={{
                            sx: {
                                fontSize: "16px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#0160F1",
                            },
                        }}
                    /> */}
                    <CardHeader
                        p={2}
                        sx={{
                            backgroundColor: "#F8F8F9",
                            fontWeight: "700",
                            borderTopRightRadius: "5px",
                            borderTopLeftRadius: "5px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                        title={
                            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Typography
                                    sx={{
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        lineHeight: "16px",
                                        color: "#0160F1",
                                    }}
                                >
                                    Filters
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: "16px",
                                        lineHeight: "16px",
                                        color: "#0160F1",
                                        opacity: fromlocation === '' && tolocation === '' && selectedOption === 'Select Creation Date' && uploadername === '' ? 0.5 : 1
                                    }}
                                    onClick={() => {
                                        if (!(fromlocation === '' && tolocation === '' && selectedOption === 'Select Creation Date' && uploadername === '')) {
                                            clearFilter();
                                        }
                                    }}
                                >
                                    Clear Filter
                                </Typography>

                            </Box>
                        }
                    />
                    <Divider />
                    <CardContent sx={styles.filterCardContent} >
                        <Grid container Spacing={2}>
                            <Grid item xs={12} sm={6} md={3} lg={2.5}>
                                <Typography sx={styles.fontSizeFiftin}>From Location :</Typography>
                                <FormControl sx={styles.locationsCard}>
                                    <Select
                                        displayEmpty
                                        size='small'
                                        sx={styles.fontSizeFiftin}
                                        value={fromlocation}
                                        label="Select From Location"
                                        onChange={handleChangeFromLocation}
                                    >
                                        <MenuItem value="">
                                            <em sx={styles.fontSizeFiftin}>Select From Location</em>
                                        </MenuItem>
                                        {fromlocationOptions.map((option) => (
                                            <MenuItem key={option} value={option} sx={styles.fontSizeFiftin}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.5}>
                                <Typography sx={styles.fontSizeFiftin}>To Location :</Typography>
                                <FormControl sx={styles.locationsCard}>
                                    <Select
                                        displayEmpty
                                        size='small'
                                        sx={styles.fontSizeFiftin}
                                        value={tolocation}
                                        label="Select To Location"
                                        onChange={handleChangeToLocation}
                                    >
                                        <MenuItem value="">
                                            <em sx={styles.fontSizeFiftin}>Select To Location</em>
                                        </MenuItem>
                                        {tolocationOptions.map((option) => (
                                            <MenuItem key={option} value={option} sx={styles.fontSizeFiftin}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.5}>
                                <Typography sx={styles.fontSizeFiftin}>Creation Date :</Typography>
                                <div>
                                    <Select
                                        size='small'
                                        value={selectedOption}
                                        onChange={handleOptionChange}
                                        wordWrap='break-word'
                                        renderValue={(selected) => {
                                            switch (selected) {
                                                case 'This Month':
                                                    return `${getMonthName(today)} 1-${new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()}`;
                                                case 'Last Month':
                                                    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
                                                case 'Last 7 days':
                                                    return `${formatDate(new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000))} - ${formatDate(today)}`;
                                                case 'Last 30 days':
                                                    return `${formatDate(new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000))} - ${formatDate(today)}`;
                                                case 'Yesterday':
                                                    return formatDate(new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000));
                                                case 'Today':
                                                    return formatDate(new Date(today.getTime()));
                                                default:
                                                    return selected;
                                            }
                                        }}
                                        sx={styles.datePickerDiv}
                                    >
                                        <MenuItem value="Today" sx={styles.fontSizeFiftin}>Today</MenuItem>
                                        <MenuItem value="Yesterday" sx={styles.fontSizeFiftin}>Yesterday</MenuItem>
                                        <MenuItem value="This Month" sx={styles.fontSizeFiftin}>This Month</MenuItem>
                                        <MenuItem value="Last Month" sx={styles.fontSizeFiftin}>Last Month</MenuItem>
                                        <MenuItem value="Last 7 days" sx={styles.fontSizeFiftin}>Last 7 days</MenuItem>
                                        <MenuItem value="Last 30 days" sx={styles.fontSizeFiftin}>Last 30 days</MenuItem>
                                        <MenuItem value="Custom" sx={styles.fontSizeFiftin}>Custom</MenuItem>
                                    </Select>
                                    <Box >
                                        {selectedOption === "Custom" && (
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item >
                                                    <Typography sx={styles.fontSizeFiftin}>Start Date:</Typography>
                                                    <StyledDatePicker selected={startDate} onChange={handleStartDateChange} maxDate={new Date()} />
                                                </Grid>
                                                <Grid item  >
                                                    <Typography sx={styles.fontSizeFiftin}>End Date:</Typography>
                                                    <StyledDatePicker selected={endDate} onChange={handleEndDateChange} minDate={startDate} maxDate={new Date()} />
                                                </Grid>
                                            </Grid>
                                        )}

                                    </Box>
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2} lg={2}>
                                <Typography sx={{ fontSize: 15 }}>Select Uploader Name</Typography>
                                <FormControl sx={{ maxWidth: 200, minWidth: 200, marginTop: 1, marginBottom: 1 }}>
                                    <Select
                                        displayEmpty
                                        size="small"
                                        sx={{ fontSize: 15 }}
                                        value={uploadername}
                                        onChange={handleChangeUploadername}
                                        renderValue={(selected) => {
                                            return selected ? selected : <em style={{ color: "black" }}>Select Uploader Name</em>;
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>Select Uploader Name</em>
                                        </MenuItem>
                                        {uploaderOptions?.map((option) => (
                                            <MenuItem key={option} value={option} sx={{ fontSize: 15 }}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid xl={1} lg={2} md={2} sm={12} xs={12} item sx={styles.filterDataButton}>
                                <SSPCommonButton
                                    btnText={"Filter Data"}
                                    btnFunction={handleFilterData}
                                />
                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
                <Card sx={styles.refreshPageCard} >
                    <CardHeader
                        p={2}
                        sx={styles.transferReqCard}
                        title={"Transfer Requests"}
                        titleTypographyProps={{
                            sx: {
                                fontSize: "16px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#0160F1",
                            },
                        }}
                        action={
                            <>
                                <Button onClick={() => window.location.reload()}>
                                    Refresh Page
                                </Button>
                            </>
                        }
                    />
                    <Divider />
                    <CardContent sx={styles.tableCardContent} >
                        {loading && (
                            <div style={styles.loaderOverlay}>
                                <CircularProgress />
                            </div>
                        )}
                        <Box sx={{ display: { lg: "flex" }, }} >
                        </Box>
                        <div>
                            <div style={{ height: 700, width: '100%' }}>
                                <DataGrid
                                    rowHeight={80}
                                    showCellRightBorder={true}
                                    sx={{
                                        ".MuiDataGrid-columnHeaderTitle": {
                                            fontWeight: "bold !important",
                                        },
                                        overflowX: "scroll",
                                    }}
                                    rows={rows}
                                    columns={columns(handleDownloadInvoice, handleDownloadEwb, handleViewDataClick, handleImage)}

                                    headerClassName="header-center"
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}

                                    rowsPerPageOptions={[10]}
                                    pageSize={10}
                                    getRowId={(row) => row.id}
                                    components={{
                                        Toolbar: GridToolbar,
                                    }}
                                    componentsProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        {storesModalOpen && (
                            <SSPCommonModal
                                open={storesModalOpen}
                                handleOpenClose={setStoresModalOpen}
                                message={<StoresDataTable data={storesData} />}
                            />
                        )}
                        {renderImageSliderDialog()}

                        {modalOpener && (
                            <SSPCommonModal
                                open={modalOpener}
                                handleOpenClose={setmodalOpener}
                                message={message}
                            />
                        )}
                    </CardContent>
                </Card>
                {/* Video  */}
                <SSPCommonVideo
                    headerText={"Demo Video"}
                    videoUrl={"https://www.youtube.com/embed/zJhH4Rgrto8?si=vRLlLSAlY0OEh4zc"}
                />
            </Box>
        </>
    );
};

export default View_Transfer